import { createSlice } from "@reduxjs/toolkit";
import { CommonResponse } from "types/types";

const initialState: CommonResponse["data"] = {
  email: null,
  token: null,
  first_name: null,
  last_name: null,
  customer_id: null,
  id: null,
};

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUser: (state, action: { payload: CommonResponse["data"] }) => {
      state.email = action.payload.email;
      state.id = action.payload.id;
      state.first_name = action.payload.first_name;
      state.last_name = action.payload.last_name;
      state.token = action.payload.token;
      state.customer_id = action.payload.customer_id;
    },
    clearUser: () => {
      return initialState;
    },
  },
});

export const currentUser = (state: { user: CommonResponse["data"] }) =>
  state.user;

export const { setUser, clearUser } = userSlice.actions;

export default userSlice.reducer;
